import React from "react";
import {Link} from "react-router-dom";
import "./home.scss";

export default function userDetails({ userDetails }) {
	return (
		<div className="user-details-container">
			<div>
				<p>
					Welcome <span className="username-color">{userDetails.user.first_name}</span>
				</p>
				<h6>
					From {userDetails.user.city}, {userDetails.user.state}
				</h6>
			</div>
			<div>
				<Link to="/nutrition/journal" className="btn btn-primary homepage-journal-link">
					<span className="nav-icon">
						<i className={`icon icon-add-to-journal`} />
					</span>
					GO TO JOURNAL
				</Link>
				<Link to="/refer-a-friend" className="btn btn-primary">
					<span className="nav-icon">
						<i className={`icon icon-friends`} />
					</span>
					REFER A FRIEND
				</Link>
			</div>
		</div>
	);
}
